import useAcl from "../../hooks/useAcl";
import Slot from "../Slot";
var Then = Slot();
var Else = Slot();
var AclIfElse = function AclIfElse(_ref) {
  var sujet = _ref.sujet,
    action = _ref.action,
    children = _ref.children;
  var isAllow = useAcl(sujet, action);
  var _then = Then.get(children, false, children);
  var _else = Else.get(children, false, null);
  return isAllow ? _then : _else;
};
AclIfElse.Then = Then;
AclIfElse.Else = Else;
export default AclIfElse;